import React, { useState, useEffect, useRef, useCallback } from 'react'
import useIsMobile from '../../hooks/useIsMobile'
import './Pagination.css'

const Pagination = ({
  data = [],
  itemsPerPage = 4,
  mobileItemsPerPage,
  variant,
  children,
  autoplay = false,
  autoplayInterval = 5000,
  controlsAlignment = 'left',
  infinite = false,
}) => {
  const isMobile = useIsMobile()
  const [currentPage, setCurrentPage] = useState(1)
  const actualItemsPerPage =
    isMobile && mobileItemsPerPage ? mobileItemsPerPage : itemsPerPage
  const totalItems = data?.length || 0
  const totalPages = Math.ceil(totalItems / actualItemsPerPage)
  const isHome = variant === 'home'
  const autoplayRef = useRef(null)
  const [resetTimer, setResetTimer] = useState(0)

  const handleNext = useCallback(() => {
    if (totalPages <= 1) return
    setCurrentPage((prev) => {
      if (prev < totalPages) return prev + 1
      return infinite ? 1 : prev
    })
    if (autoplay) setResetTimer((v) => v + 1)
  }, [totalPages, infinite, autoplay])

  const handlePrev = useCallback(() => {
    if (totalPages <= 1) return
    setCurrentPage((prev) => {
      if (prev > 1) return prev - 1
      return infinite ? totalPages : prev
    })
    if (autoplay) setResetTimer((v) => v + 1)
  }, [totalPages, infinite, autoplay])

  useEffect(() => {
    const shouldAutoplay = autoplay && totalPages > 1 && (!isMobile || isHome)
    if (shouldAutoplay) {
      autoplayRef.current = setInterval(handleNext, autoplayInterval)
    }
    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current)
    }
  }, [autoplay, handleNext, autoplayInterval, totalPages, isMobile, isHome, resetTimer])

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1)
    }
  }, [totalPages, currentPage])

  const showAllOnMobile = isMobile && !isHome
  const pages = []
  if (showAllOnMobile) {
    pages.push(data)
  } else {
    for (let i = 1; i <= totalPages; i++) {
      const start = (i - 1) * actualItemsPerPage
      pages.push(data.slice(start, start + actualItemsPerPage))
    }
  }

  const SetaIcon = '/assets/Home/setaDireita.png'

  if (!data || data.length === 0) return null

  return (
    <div
      className={`pagination-component ${isHome ? 'pagination-home' : ''} ${
        infinite ? 'infinite' : ''
      }`}
    >
      {children && (
        <div className="carousel-container">
          <div
            className="carousel-track"
            style={{
              transform: showAllOnMobile
                ? 'none'
                : `translateX(-${(currentPage - 1) * 100}%)`,
            }}
          >
            {pages.map((pageData, index) => (
              <div key={index} className="carousel-page">
                {children(pageData)}
              </div>
            ))}
          </div>
        </div>
      )}

      {totalPages > 1 && (!isMobile || isHome) && (
        <div className={`pagination-controls ${controlsAlignment}`}>
          <button
            onClick={handlePrev}
            disabled={!infinite && currentPage === 1}
            className="pagination-btn"
          >
            {isHome ? (
              <img
                src={SetaIcon}
                alt="Anterior"
                style={{ transform: 'rotate(180deg)' }}
              />
            ) : (
              '←'
            )}
          </button>

          {!isHome && (
            <span className="page-info">
              Página {currentPage} de {totalPages}
            </span>
          )}

          <button
            onClick={handleNext}
            disabled={!infinite && currentPage === totalPages}
            className="pagination-btn"
          >
            {isHome ? <img src={SetaIcon} alt="Próximo" /> : '→'}
          </button>
        </div>
      )}
    </div>
  )
}

export default Pagination
